import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_OFFRE_EMPLOI_BY_DEMANDE_REQUEST,
    GENERATE_OFFRE_EMPLOI_REQUEST,
    PUBLISH_OFFRE_EMPLOI_CAREERS_REQUEST,
    fetchOffreEmploiByDemandeFail,
    fetchOffreEmploiByDemandeSuccess,
    generateOffreEmploiFail,
    generateOffreEmploiSuccess,
    SAVE_OFFRE_EMPLOI_DRAFT_REQUEST,
    saveOffreEmploiDraftFail,
    saveOffreEmploiDraftSuccess,
} from "../actions/offresEmploiActions";
import { API_BASE_URL, getRequest, postRequest, putRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* generateOffreEmploiSaga(action) {
    const url = `${API_BASE_URL}/api/offres-emploi/generate`;
    const uid = getUid();
    const token = getToken();

    try {
        const response = yield call(postRequest, {
            url,
            data: action.payload,
            uid,
            token,
        });

        yield put(generateOffreEmploiSuccess(response.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Offre générée avec succès",
            timer: 1800,
            showConfirmButton: false,
        });
    } catch (e) {
        const message = e.response?.data?.message || "Erreur lors de la génération de l'offre";
        yield put(generateOffreEmploiFail(message));

        yield call([Swal, Swal.fire], {
            icon: "error",
            text: message,
            timer: 2600,
            showConfirmButton: false,
        });
    }
}

export function* fetchOffreEmploiByDemandeSaga(action) {
    const demandeId = action.payload;
    const url = `${API_BASE_URL}/api/offres-emploi/by-demande/${demandeId}`;
    const token = getToken();

    try {
        const response = yield call(getRequest, {
            url,
            token,
        });

        yield put(fetchOffreEmploiByDemandeSuccess(response.data));
    } catch (e) {
        if (e.response?.status === 404) {
            yield put(fetchOffreEmploiByDemandeFail(null));
            return;
        }

        const message = e.response?.data?.message || "Erreur lors du chargement du brouillon";
        yield put(fetchOffreEmploiByDemandeFail(message));
    }
}

export function* saveOffreEmploiDraftSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/offres-emploi/${id}`;
    const uid = getUid();
    const token = getToken();

    try {
        const response = yield call(putRequest, {
            url,
            data: payload,
            uid,
            token,
        });

        yield put(saveOffreEmploiDraftSuccess(response.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Brouillon enregistré avec succès",
            timer: 1800,
            showConfirmButton: false,
        });
    } catch (e) {
        const message = e.response?.data?.message || "Erreur lors de l'enregistrement du brouillon";
        yield put(saveOffreEmploiDraftFail(message));

        yield call([Swal, Swal.fire], {
            icon: "error",
            text: message,
            timer: 2600,
            showConfirmButton: false,
        });
    }
}

export function* publishOffreEmploiCareersSaga() {
    yield call([Swal, Swal.fire], {
        icon: "info",
        text: "La publication sur Careers sera activée à l'étape suivante.",
        timer: 2200,
        showConfirmButton: false,
    });
}

export default function* offresEmploiSaga() {
    yield takeLatest(FETCH_OFFRE_EMPLOI_BY_DEMANDE_REQUEST, fetchOffreEmploiByDemandeSaga);
    yield takeLatest(GENERATE_OFFRE_EMPLOI_REQUEST, generateOffreEmploiSaga);
    yield takeLatest(SAVE_OFFRE_EMPLOI_DRAFT_REQUEST, saveOffreEmploiDraftSaga);
    yield takeLatest(PUBLISH_OFFRE_EMPLOI_CAREERS_REQUEST, publishOffreEmploiCareersSaga);
}
